<template>
    <div class="imglist">
        <div class="container">
            <div class="img_box hvr-grow" v-for="(item, index) in imgList" :key="index">
                <a :href="item.ads_link">
                    <img :src="item.ads_img" v-if="item.ads_img && item.ads_img.indexOf('http') != -1" alt="">
                    <img :src="$ImgUrl + item.ads_img" v-if="item.ads_img && item.ads_img.indexOf('http') == -1" alt="">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                imgList: []
            }
        },
        mounted () {
            this.getImgList();
        },
        methods: {
            // 获取图片
            async getImgList() {
                let res = await this.$axios.post("/lencon/pc/index/banner", { type: 6 })
                if ( res.data.code == 1 ) {
                    this.imgList = res.data.res
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
.imglist {
    width: 100%;
    .container {
        width: 1200px;
        margin: 20px auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .img_box {
            width: 378px;
            height: 94px;
            background-color: #f5f5f5;
            img {
                width: 378px;
                height: 94px;
            }
        }
    }

}
</style>